module.exports = __webpack_public_path__ + "img/d4sj-btn.81e65529.png";